module.exports = __webpack_public_path__ + "static/media/kv-ko.22bf10bb.jpg";